(function () {
  'use strict';

  const section = document.querySelector('[data-pdp-rails]');
  if (!section) return;

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ── Recently viewed (localStorage) ──────────── */
  const RV_KEY = 'bellascena:recently-viewed';
  const RV_MAX = 12;

  function getRecent() {
    try { return JSON.parse(localStorage.getItem(RV_KEY) || '[]'); } catch (e) { return []; }
  }
  function saveRecent(list) {
    try { localStorage.setItem(RV_KEY, JSON.stringify(list.slice(0, RV_MAX))); } catch (e) {}
  }

  // Alleen de handle bewaren. Hier stonden eerder ook de titel, de prijs en het
  // adres in, en dat is een momentopname: wie een product in het Engels bekeek
  // en daarna op Nederlands overstapte, hield de Engelse titel, de oude valuta
  // en een adres zonder markt-prefix. De handle verandert nooit; de rest halen
  // we op in de taal en de valuta van dat moment.
  const productJson = document.querySelector('[data-product-json]');
  if (productJson) {
    try {
      const p = JSON.parse(productJson.textContent);
      const list = getRecent().filter(x => x.handle !== p.handle);
      list.unshift({ handle: p.handle });
      saveRecent(list);
    } catch (e) { /* ignore */ }
  }

  // De kaarten worden opgebouwd uit verse productgegevens van de huidige markt.
  // /products/<handle>.js geeft de titel in de taal van die markt en de prijs in
  // de valuta ervan. Uit de opslag komt alleen de handle.
  async function buildRecentCards(container) {
    const root = (section.dataset.railsRoot || '/').replace(/\/$/, '') + '/';
    const saleLabel = section.dataset.railsSale || '';
    const huidig = window.location.pathname.split('/').pop();
    const handles = getRecent()
      .map(x => x && x.handle)
      .filter(h => h && h !== huidig)
      .slice(0, 8);
    if (handles.length === 0) return 0;

    const producten = (await Promise.all(
      handles.map(h =>
        fetch(root + 'products/' + encodeURIComponent(h) + '.js')
          .then(r => (r.ok ? r.json() : null))
          .catch(() => null)
      )
    )).filter(Boolean);
    if (producten.length === 0) return 0;

    // Intl volgt de valuta van de markt en de schrijfwijze van het land:
    // 43,95 EUR wordt "43,95 €" in het Frans en "€ 43,95" in het Nederlands.
    const currency =
      (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
    const fmt = (cents) => {
      try {
        return new Intl.NumberFormat(document.documentElement.lang || undefined, {
          style: 'currency',
          currency: currency,
        }).format(Number(cents) / 100);
      } catch (e) {
        return (Number(cents) / 100).toFixed(2);
      }
    };
    const veilig = (s) =>
      String(s == null ? '' : s).replace(/[&<>"']/g, (c) =>
        ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c])
      );

    container.innerHTML = producten.map(p => {
      const onSale = p.compare_at_price && Number(p.compare_at_price) > Number(p.price);
      const raw = p.featured_image || (p.images && p.images[0]) || '';
      const sized = (u, w) => u + (u.indexOf('?') >= 0 ? '&' : '?') + 'width=' + w;
      const imgAttrs = raw
        ? `src="${sized(raw, 280)}" srcset="${sized(raw, 200)} 200w, ${sized(raw, 280)} 280w, ${sized(raw, 420)} 420w" sizes="(min-width: 1200px) 14vw, (min-width: 900px) 20vw, (min-width: 600px) 33vw, 31vw"`
        : '';
      const titel = veilig(p.title);
      return `
        <a class="bellascena-rails__card" href="${root}products/${encodeURIComponent(p.handle)}" data-rail-card data-product-handle="${veilig(p.handle)}">
          <div class="bellascena-rails__card-media">
            ${raw ? `<img class="bellascena-rails__card-img bellascena-rails__card-img--primary" ${imgAttrs} alt="${titel}" loading="lazy" width="280" height="373" onerror="var r=this.closest('[data-rail-recent]');this.closest('[data-rail-card]').remove();if(r&&!r.querySelector('[data-rail-card]'))r.hidden=true">` : ''}
            ${onSale && saleLabel ? `<span class="bellascena-rails__card-seal">${veilig(saleLabel)}</span>` : ''}
          </div>
          <div class="bellascena-rails__card-info">
            <span class="bellascena-rails__card-name">${titel}</span>
            <span class="bellascena-rails__card-price">
              <em>${fmt(p.price)}</em>
              ${onSale ? `<del>${fmt(p.compare_at_price)}</del>` : ''}
            </span>
          </div>
        </a>
      `;
    }).join('');
    return producten.length;
  }

  /* ── Wishlist (localStorage) ──────────── */
  const WISH_KEY = 'bellascena:wishlist';
  function getWish() { try { return JSON.parse(localStorage.getItem(WISH_KEY) || '[]'); } catch (e) { return []; } }
  function saveWish(list) { try { localStorage.setItem(WISH_KEY, JSON.stringify(list)); } catch (e) {} }

  function initWish(scope) {
    scope.querySelectorAll('[data-rail-wish]').forEach(btn => {
      if (btn.dataset.wishInit) return;
      btn.dataset.wishInit = '1';
      const card = btn.closest('[data-product-handle]');
      if (!card) return;
      const handle = card.dataset.productHandle;
      if (getWish().includes(handle)) btn.classList.add('is-saved');
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        const list = getWish();
        const idx = list.indexOf(handle);
        if (idx >= 0) { list.splice(idx, 1); btn.classList.remove('is-saved'); }
        else { list.push(handle); btn.classList.add('is-saved'); }
        saveWish(list);
      });
    });
  }

  /* ── Rail pagination (arrows on desktop) + dots (mobile) ──────────── */
  function initRail(rail) {
    if (rail.dataset.railInit) return;
    const track = rail.querySelector('[data-rail-track]');
    if (!track) return;
    rail.dataset.railInit = '1';

    const prev = rail.querySelector('[data-rail-prev]');
    const next = rail.querySelector('[data-rail-next]');
    const pag = rail.querySelector('[data-rail-pag]');
    const dots = rail.querySelector('[data-rail-dots]');

    function metrics() {
      const cards = track.querySelectorAll('.bellascena-rails__card');
      if (!cards.length) return null;
      const cardW = cards[0].offsetWidth + parseInt(getComputedStyle(track).gap || 10);
      const visible = Math.max(1, Math.round(track.offsetWidth / cardW));
      const pages = Math.max(1, Math.ceil(cards.length / visible));
      const current = Math.min(pages, Math.floor(track.scrollLeft / (cardW * visible)) + 1);
      return { cardW, visible, pages, current };
    }

    function update() {
      const m = metrics();
      if (!m) return;
      if (pag) pag.innerHTML = String(m.current).padStart(2, '0') + '<em>/</em>' + String(m.pages).padStart(2, '0');
      if (prev) prev.disabled = track.scrollLeft <= 0;
      if (next) next.disabled = Math.ceil(track.scrollLeft + track.offsetWidth) >= track.scrollWidth - 2;
      if (dots) {
        if (dots.children.length !== m.pages) {
          let h = '';
          for (let i = 0; i < m.pages; i++) h += '<i></i>';
          dots.innerHTML = h;
        }
        for (let j = 0; j < dots.children.length; j++) {
          dots.children[j].classList.toggle('is-active', j === m.current - 1);
        }
      }
    }

    function scrollByPage(dir) {
      const m = metrics();
      if (!m) return;
      track.scrollBy({ left: dir * m.cardW * m.visible, behavior: reducedMotion ? 'auto' : 'smooth' });
    }

    if (prev) prev.addEventListener('click', () => scrollByPage(-1));
    if (next) next.addEventListener('click', () => scrollByPage(1));

    let ticking = false;
    track.addEventListener('scroll', () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => { update(); ticking = false; });
    }, { passive: true });

    requestAnimationFrame(update);
    window.addEventListener('resize', update);
  }

  /* ── De-duplicate across rails: a product shows in only ONE rail (top rail wins) ──────────── */
  function dedupeRails() {
    const seen = new Set();
    const cur = window.location.pathname.split('/').pop();
    if (cur) seen.add(cur);
    section.querySelectorAll('[data-rail]').forEach(rail => {
      if (rail.hasAttribute('hidden')) return;
      rail.querySelectorAll('[data-product-handle]').forEach(card => {
        const h = card.dataset.productHandle;
        if (!h) return;
        if (seen.has(h)) card.remove();
        else seen.add(h);
      });
      // Hide a secondary rail if de-duping thinned it out (rail 1 always stays)
      const isSecondary = rail.hasAttribute('data-rail-recent') || !!rail.closest('[data-rail-related]');
      if (isSecondary && rail.querySelectorAll('.bellascena-rails__card').length < 2) {
        rail.setAttribute('hidden', '');
      }
    });
    window.dispatchEvent(new Event('resize'));
  }

  /* ── Rail 3: Recently viewed ──────────── */
  const recentRail = section.querySelector('[data-rail-recent]');
  if (recentRail) {
    const track = recentRail.querySelector('[data-rail-recent-track]');
    // Ophalen is nu asynchroon, dus de rij verschijnt zodra de gegevens er zijn.
    buildRecentCards(track).then(function (count) {
      // Pas tonen vanaf twee producten — één eenzame kaart oogt slechter dan geen.
      if (count >= 2) {
        recentRail.hidden = false;
        initRail(recentRail);
        initWish(recentRail);
        dedupeRails();
      }
    });
  }

  /* ── Rail 2: You may also like (Shopify related, fetched) ──────────── */
  const related = section.querySelector('[data-rail-related]');
  if (related && !related.querySelector('[data-rail]')) {
    const url = related.getAttribute('data-related-url');
    if (url) {
      fetch(url)
        .then(r => r.text())
        .then(html => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const fresh = doc.querySelector('[data-rail-related]');
          if (fresh && fresh.querySelector('[data-rail]')) {
            related.innerHTML = fresh.innerHTML;
            const newRail = related.querySelector('[data-rail]');
            if (newRail) initRail(newRail);
            initWish(related);
            dedupeRails();
          }
        })
        .catch(() => {});
    }
  }

  /* ── Init rails already in the DOM (rail 1) + their wishlist ──────────── */
  section.querySelectorAll('[data-rail]').forEach(rail => {
    if (rail.hasAttribute('hidden')) return; // recently-viewed handled above
    initRail(rail);
  });
  initWish(section);
})();
